import React from 'react';
import PropTypes from 'prop-types';

const Container = ({ children, small }) => {
  const styles = {
    width: small ? '40%' : '90%',
    maxWidth: '1400px',
    margin: '0 auto'
  };

  return <div style={styles}>{children}</div>;
};

Container.propTypes = {
  small: PropTypes.bool
};

export default Container;
